import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAPIURL } from "helpers";
import { getBaseQueryWithRejection } from "redux/helper.redux";

const baseQueryWithRejection = getBaseQueryWithRejection(
    fetchBaseQuery({
        baseUrl: getAPIURL("/api/pvsa/mission-expert"),
        prepareHeaders: (headers, { getState }) => {
            const token = getState().auth.accessToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    })
);

export const missionExpertApi = createApi({
    reducerPath: "missionExpertApi",
    baseQuery: baseQueryWithRejection,
    tagTypes: ['MissionExpert'],
    endpoints: (builder) => ({
        getMissionExpertData: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                if (params.missionId) tmp.append('mission-id', params.missionId);
                if (params.movementId) tmp.append('movement-id', params.movementId);
                if (params.userId) tmp.append('user-id', params.userId);
                return `?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: ["MissionExpert"]
        }),
        saveMissionExpertData: builder.mutation({
            query: (obj) => ({
                url: `/`,
                method: "POST",
                body: obj,
            }),
            invalidatesTags: ["MissionExpert"],
        }),
        deleteMissionExpertData: builder.mutation({
            query: (id) => ({
                url: `/${id}`,
                method: "DELETE",
                transformResponse: (response) => response.data,
            }),
            invalidatesTags: ["MissionExpert"]
        }),
        getMissionExpertLatestInfo: builder.query({
            query: (params) => {
                const tmp = new URLSearchParams();
                if (params.missionId) tmp.append('mission-id', params.missionId);
                if (params.userId) tmp.append('user-id', params.userId);
                return `/get-latest-info?${tmp.toString()}`;
            },
            transformResponse: (response) => response.data,
            providesTags: ["MissionExpert"]
        }),
    }),
});

export const {
    useGetMissionExpertDataQuery, 
    useSaveMissionExpertDataMutation,
    useDeleteMissionExpertDataMutation,
    useGetMissionExpertLatestInfoQuery,
    useLazyGetMissionExpertLatestInfoQuery
} = missionExpertApi;
